
// vue
import { ref, reactive, defineComponent } from 'vue';

// firebase
import 'firebase/firestore';
import { db } from '@/main';

// atoms
import CustomButton from '@/components/atoms/CustomButton.vue';

// types
import { ServerTimestamp } from '@/types';

export default defineComponent({
  name: 'Student',
  components: {
    CustomButton,
  },
  setup() {
    // 期限切れかどうか判定（削除ページ専用関数）
    const isExpired = (createdAt: ServerTimestamp, expirationDate: number) => {
      const now = new Date();
      const expired = createdAt.toDate();
      expired.setDate(expired.getDate() + expirationDate);
      return expired < now;
    };

    const totalRoom = ref(0);
    const expiredRoom = ref(0);
    db.collection('Room')
      .get()
      .then((snapshot) => {
        snapshot.forEach((doc) => {
          totalRoom.value++;
          const data = doc.data();
          const createdAt = data?.createdAt;
          const expirationDate = data?.expirationDate;
          if (isExpired(createdAt, expirationDate)) {
            expiredRoom.value++;
          }
        });
      });

    const deleteExpiredRoom = async () => {
      try {
        const snapshot = await db.collection('Room').get();

        snapshot.forEach(async (doc) => {
          const roomId = doc.id;
          const data = doc.data();
          const createdAt = data?.createdAt;
          const expirationDate = data?.expirationDate;
          if (!isExpired(createdAt, expirationDate)) return;

          // チャット削除
          const msgSnaoshot = await db
            .collection('Room')
            .doc(roomId)
            .collection('messages')
            .get();
          msgSnaoshot.forEach(async (msgDoc) => {
            const msgId = msgDoc.id;
            await db
              .collection('Room')
              .doc(roomId)
              .collection('messages')
              .doc(msgId)
              .delete();
          });

          // 質問削除
          const questionSnaoshot = await db
            .collection('Room')
            .doc(roomId)
            .collection('questions')
            .get();
          questionSnaoshot.forEach(async (questionDoc) => {
            const msgId = questionDoc.id;
            await db
              .collection('Room')
              .doc(roomId)
              .collection('questions')
              .doc(msgId)
              .delete();
          });

          // ルーム削除
          await db.collection('Room').doc(roomId).delete();
        });
        alert(`削除が完了しました`);
      } catch (e) {
        console.error(e);
        alert('削除に失敗しました');
      }
    };

    const expiredUsers = reactive<string[]>([]);
    const beforeHalfYear = new Date();
    beforeHalfYear.setDate(beforeHalfYear.getMonth() + 1 - 6);
    db.collection('Users')
      .where('updatedAt', '<', beforeHalfYear)
      .get()
      .then((snapshot) => {
        snapshot.forEach((doc) => {
          expiredUsers.push(doc.id);
        });
      });

    const deleteExpiredUsers = async () => {
      try {
        for (const expiredUserId of expiredUsers) {
          db.collection('Users').doc(expiredUserId).delete();
        }
        alert(`削除が完了しました`);
      } catch (e) {
        console.error(e);
        alert('削除に失敗しました');
      }
    };

    return {
      totalRoom,
      expiredRoom,
      expiredUsers,
      deleteExpiredUsers,
      deleteExpiredRoom,
    };
  },
});
